import {gsap} from "gsap";

const Location = {

    init() {
        this.el = $('[page="lokalita"]');
        if (!this.el.length) return;

        this.categories = this.el.find('.categories li');
        this.points = this.el.find('.point');
        this.filterBtn = this.el.find('.filter');
        this.nav = this.el.find('nav');
        this.bind();

        $(this.categories[0]).trigger('click');
        this.scrollToCenter();
    },

    bind() {
        this.filterBtn.click((evt) => {
            this.toggleFilter(!$(evt.currentTarget).is('.active'));
        })

        this.categories.click((evt) => {
            this.filter($(evt.currentTarget));
        })

        this.points.mouseenter((evt) => {
            $(evt.currentTarget).find('.bubble').addClass('visible');
        })

        this.points.mouseleave((evt) => {
            $(evt.currentTarget).find('.bubble').removeClass('visible');
        })
    },

    toggleFilter(open){
        if(open){
            gsap.set(this.nav, {height:'auto'});
            gsap.from(this.nav, {height:0, ease:"power2.out"});

        } else {
            gsap.to(this.nav, {height:0, ease:"power2.out"});
        }

        this.filterBtn.toggleClass('active', open);
    },

    filter(category) {
        const id = category.attr('id');
        category.addClass('selected').siblings('li').removeClass('selected');

        if (id === 'all') {
            this.show(this.points);
        } else {
            this.hide(this.points.filter('.active'));
            this.show(this.points.filter('[id="' + id + '"]'));
        }

        if(this.filterBtn.is('.active')) {
            this.toggleFilter(false);
        }

    },

    show(points) {
        points.addClass('active');
        gsap.fromTo(points, {opacity: 0, y: -50}, {opacity: 1, y: 0, overwrite: true, stagger: 0.05, duration: 0.5, ease: 'bounce.out'})
    },

    hide(points) {
        points.removeClass('active');
        gsap.to(points, {opacity: 0, overwrite: true, duration: 0.3})
    },

    scrollToCenter(){
        const left = this.el.find('.holder').outerWidth() * 0.40;
        gsap.to(this.el.find('.map'), {scrollTo: {x: left}})
    }
}

export default Location;